// ARCA-82 WS2 — Center-Dialog primitive (UI-SPEC §5 modal FSM).
//
// The canonical take-two celebratory / confirm flavor: a paper card that pops in
// centered (Docs/UI-prototype take two .dialog). Use for level-ups, win/loss
// moments, confirmations, alerts, and short forms that want the user's full
// focus mid-screen. Action pickers that reach up from the thumb zone use <Sheet>.
//
// Dismissal: scrim-tap + Escape (no close-x). All scrim/panel styling lives in
// pieces.css; pass panelStyle only for layout the .dialog recipe can't express.

import type { CSSProperties, JSX, ReactNode } from 'react'

import { ModalScrim } from './ModalScrim'

export interface DialogProps {
  readonly onClose: () => void
  readonly labelledBy?: string
  readonly describedBy?: string
  readonly testId?: string
  readonly dismissOnScrimTap?: boolean
  readonly scrimClassName?: string
  readonly scrimStyle?: CSSProperties
  readonly panelClassName?: string
  readonly panelStyle?: CSSProperties
  readonly children: ReactNode
}

export function Dialog(props: DialogProps): JSX.Element {
  return <ModalScrim variant="dialog" {...props} />
}
